module.exports = __webpack_public_path__ + "static/img/sggs_img_2.0e452269.png";